import React from 'react';
import { useStore } from '../state/zustand-store';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface NoDataOverlayProps {
  title?: string;
  icon: React.ReactNode;
  message?: string;
}

export default function NoDataOverlay({
  title,
  icon,
  message,
}: NoDataOverlayProps) {
  const { colorMode } = useStore();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        textAlign: 'center',
        px: 2,
        bgcolor: (theme) =>
          colorMode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon}
        <Typography variant="h5">{title}</Typography>
      </Stack>
      <Typography variant="body1" mt={1}>
        {message}
      </Typography>
    </Box>
  );
}
